import React, { useState } from 'react';

type DescriptionPopupProps = {
    description: string;
  };

const DescriptionPopup: React.FC<DescriptionPopupProps> = ({description}) => {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <div>
      <button onClick={() => setShowPopup(true)}>Show Description</button>

      {showPopup && (
        <div style={styles.overlay}>
          <div style={styles.popup}>
            <p>{description}</p>
            <button onClick={() => setShowPopup(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
    zIndex: 999,
  },
  popup: {
    backgroundColor: 'black',
    padding: '20px',
    borderRadius: '8px',
    minWidth: '200px',
    maxWidth: '60%',
    boxShadow: '0 0 10px rgba(0,0,0,0.25)',
  },
  button: {
    backgroundColor: 'black',
    color:"yellow"
  }
};

export default DescriptionPopup;